import styled from 'styled-components';

export const StyledFormLogoContainer = styled.div`
  height: 40%;
  max-height: 280px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;